import { useEffect } from 'react';

const OPT_OUT_KEY = 'bolt:noWakeLock';
/** Battery-conscious opt-out (v5/P2 / full spec §20.4). */
export function wakeLockOptedOut(): boolean {
  try {
    return localStorage.getItem(OPT_OUT_KEY) === '1';
  } catch {
    return false;
  }
}
export function setWakeLockOptOut(off: boolean): void {
  try {
    if (off) localStorage.setItem(OPT_OUT_KEY, '1');
    else localStorage.removeItem(OPT_OUT_KEY);
  } catch {
    /* private mode */
  }
}

/**
 * Hold a screen Wake Lock while mounted (during a round). iOS Safari pauses
 * geolocation when the screen sleeps (§6.7) — coded now for the real-device
 * hand-off, harmless where unsupported. Re-acquires on visibility return.
 * Skipped entirely when the user has opted out (battery).
 */
export function useWakeLock() {
  useEffect(() => {
    let lock: WakeLockSentinel | null = null;
    let cancelled = false;
    const nav = navigator as Navigator & { wakeLock?: { request(type: 'screen'): Promise<WakeLockSentinel> } };
    if (!nav.wakeLock || wakeLockOptedOut()) return;

    const acquire = async () => {
      try {
        lock = await nav.wakeLock!.request('screen');
      } catch {
        /* denied / not visible */
      }
    };
    const onVisible = () => {
      if (document.visibilityState === 'visible' && !cancelled) acquire();
    };
    acquire();
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      cancelled = true;
      document.removeEventListener('visibilitychange', onVisible);
      lock?.release().catch(() => {});
    };
  }, []);
}
